import { c as _c } from "react-compiler-runtime";
import { forwardRef } from "react";
import { base } from "./Card.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const BaseCard = (t0, ref) => {
  const $ = _c(9);
  const {
    backgroundColor: t1,
    borderRadius: t2,
    boxShadow: t3,
    padding: t4,
    children
  } = t0;
  const backgroundColor = t1 === undefined ? "white" : t1;
  const borderRadius = t2 === undefined ? 0 : t2;
  const boxShadow = t3 === undefined ? "l" : t3;
  const padding = t4 === undefined ? 0 : t4;
  let t5;
  if ($[0] !== backgroundColor || $[1] !== borderRadius || $[2] !== boxShadow || $[3] !== padding) {
    t5 = base({
      backgroundColor,
      borderRadius,
      boxShadow,
      padding
    });
    $[0] = backgroundColor;
    $[1] = borderRadius;
    $[2] = boxShadow;
    $[3] = padding;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children || $[6] !== ref || $[7] !== t5) {
    t6 = /*#__PURE__*/_jsx("div", {
      className: t5,
      ref: ref,
      children: children
    });
    $[5] = children;
    $[6] = ref;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export const Card = /*#__PURE__*/forwardRef(BaseCard);
//# sourceMappingURL=Card.js.map